import { render, staticRenderFns } from "./FloatingChatButton.vue?vue&type=template&id=a9e0d95c&scoped=true&"
import script from "./FloatingChatButton.vue?vue&type=script&lang=js&"
export * from "./FloatingChatButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChatButton.vue?vue&type=style&index=0&id=a9e0d95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e0d95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
